import React from "react";
import styles from "./GetStarted.module.css";

const GetStartedEmpowering = ({ width = 100, height = 100 }) => {
    return (
        <svg viewBox="0 0 72 72" width={width} height={height}>
            <g>
                <path
                    className={styles.cls1}
                    d="M35.74,71.36c-19.48,0-35.33-15.85-35.33-35.33S16.26,0.7,35.74,0.7s35.33,15.85,35.33,35.33
		S55.23,71.36,35.74,71.36z M35.74,4.3c-17.5,0-31.73,14.23-31.73,31.73s14.23,31.73,31.73,31.73s31.73-14.23,31.73-31.73
		S53.24,4.3,35.74,4.3z"
                />
                <g>
                    <path
                        className={styles.cls1}
                        d="M23.45,44.39c-0.36,0-0.72-0.11-1.03-0.34c-0.62-0.45-0.87-1.24-0.64-1.96l2.77-8.52L17.3,28.3
			c-0.62-0.45-0.87-1.23-0.64-1.96c0.24-0.73,0.91-1.21,1.67-1.21h8.96l2.77-8.52c0.24-0.73,0.91-1.21,1.67-1.21
			c0.76,0,1.43,0.49,1.67,1.21l2.77,8.53h8.96c0.76,0,1.43,0.49,1.67,1.21c0.24,0.73-0.02,1.51-0.64,1.96l-7.63,5.54l-1.41-1.94
			l6.02-4.38H35.7c-0.76,0-1.43-0.49-1.67-1.21l-2.3-7.08l-2.3,7.08c-0.23,0.73-0.9,1.21-1.67,1.21h-7.45l6.02,4.38
			c0.62,0.45,0.87,1.23,0.64,1.96l-2.3,7.08l6.02-4.38l1.41,1.94l-7.63,5.54C24.18,44.28,23.81,44.39,23.45,44.39z M27.15,25.57
			L27.15,25.57L27.15,25.57z M36.32,25.57L36.32,25.57C36.32,25.57,36.32,25.57,36.32,25.57z"
                    />
                    <g>
                        <path
                            className={styles.cls1}
                            d="M46,40.52l-1.36-3.68c-0.07-0.2-0.23-0.3-0.35-0.35c-0.2-0.09-0.44-0.08-0.68,0
				c-0.44,0.16-0.69,0.58-0.55,0.93l-2.25,0.83c-0.59-1.59,0.3-3.4,1.97-4.02c0.8-0.3,1.67-0.28,2.43,0.03
				c0.79,0.33,1.39,0.95,1.68,1.74l1.36,3.69L46,40.52z"
                        />
                        <path
                            className={styles.cls1}
                            d="M42.21,41.99l-1.74-4.65c-0.13-0.35-0.62-0.51-1.06-0.35c-0.44,0.16-0.71,0.59-0.58,0.94l-2.25,0.83
				c-0.59-1.59,0.31-3.4,2-4.02c1.69-0.63,3.54,0.17,4.13,1.76l1.74,4.65L42.21,41.99z"
                        />
                        <path
                            className={styles.cls1}
                            d="M42.97,56.26c-0.32,0-0.65-0.01-0.99-0.03c-0.39-0.04-3.42-0.37-5.1-1.55l-7.56-4.36
				c-0.21-0.23-1.25-1.44-0.74-2.66c0.33-0.78,0.77-1.2,0.85-1.28l0.14-0.11c0.27-0.18,1-0.58,1.7-0.56
				c0.35,0.02,2.37,0.41,4.36,0.82L31,33.92c-0.54-1.47,0.27-3.14,1.81-3.71c0.73-0.27,1.52-0.26,2.23,0.03
				c0.74,0.31,1.29,0.88,1.56,1.61l3.92,10.61l-2.25,0.83l-3.92-10.61c-0.05-0.13-0.15-0.19-0.23-0.22c-0.08-0.04-0.26-0.08-0.48,0
				c-0.3,0.11-0.48,0.4-0.39,0.63l4.92,13.36c0.37,0.78,0.18,1.39,0.04,1.68c-0.3,0.61-0.91,0.91-1.38,0.99l-0.23,0.04l-0.22-0.05
				c-2.3-0.48-4.89-0.99-5.24-1.03c0.03,0.01-0.04,0.05-0.13,0.1c-0.03,0.04-0.08,0.11-0.13,0.21c0.03,0.05,0.07,0.11,0.11,0.17
				l7.25,4.13c0.86,0.63,2.87,1.03,3.93,1.14c4.58,0.27,7.57-1.72,9.25-3.42c0.43-0.43,0.69-1.12,0.78-2.03
				c0.09-0.93-0.02-1.87-0.33-2.8l-1.66-4.88l-1.35-3.65c-0.13-0.36-0.55-0.53-0.92-0.39c-0.38,0.14-0.6,0.56-0.47,0.9l-2.25,0.83
				c-0.59-1.59,0.26-3.38,1.89-3.99c1.62-0.6,3.42,0.21,4.01,1.81l1.36,3.68l1.67,4.92c0.43,1.26,0.58,2.54,0.45,3.81
				c-0.15,1.47-0.64,2.64-1.46,3.47C51.21,54.03,47.93,56.26,42.97,56.26z"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default GetStartedEmpowering;
